import SvgIcon from '@mui/material/SvgIcon';
import type { SxProps } from "@mui/material";
import React from "react";

export const GroupOfPeople2: React.FC<{ sx?: SxProps }> = ({ sx }) => {
    return (
        <SvgIcon sx={sx}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 79.24 49.741"
            >
                <g>
                    <path
                        d="M563.945,11a11,11,0,1,1-11-11,11,11,0,0,1,11,11"
                        transform="translate(-492.131 0.001)"
                        fill="#e85317"
                    />
                    <path
                        d="M495.329,279.4h-.044c-.608-6.5-7.413-11.617-15.718-11.617s-15.11,5.12-15.718,11.617H463.8l-2.637,11.984a1.259,1.259,0,0,0,1.229,1.529h34.341a1.259,1.259,0,0,0,1.229-1.529Z"
                        transform="translate(-418.756 -243.173)"
                        fill="#e85317"
                    />
                    <path
                        d="M102.809,11a11,11,0,1,1-11-11,11,11,0,0,1,11,11"
                        transform="translate(-73.375 0.001)"
                        fill="#e85317"
                    />
                    <path
                        d="M34.193,279.4h-.044c-.608-6.5-7.413-11.617-15.718-11.617S3.32,272.9,2.712,279.4H2.668L.03,291.384a1.259,1.259,0,0,0,1.229,1.529H35.6a1.259,1.259,0,0,0,1.229-1.529Z"
                        transform="translate(0 -243.173)"
                        fill="#e85317"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
};